import HistoryModal from 'components/molecules/HistoryModal';
import PdfModal from 'components/molecules/PdfModal';
import TreeModal from 'components/molecules/TreeModal';
import ValidationModal from 'components/molecules/ValidationModal';
import Footer from 'components/atoms/Footer';
import Card from 'components/molecules/Card';
import Filter from 'components/molecules/Filter';
import Pagination from 'components/molecules/Pagination';
import TypeDocSelector from 'components/molecules/TypeDocSelector';
import Results from 'components/organisms/Results';
import { GlobalContext } from 'Context/GlobalContext/AppContext';
import { useContext } from 'react';
import useSearchPage from './hooks/useSearchPage';
import SearchBar from 'components/molecules/SearchBar';
import QuantificationModal from "components/molecules/QuantificationModal";

const SearchPage = () => {
  const { historyModal, pdfModal, validationModal, treeModal, searchTerm, quantidadeModal } = useContext(GlobalContext);
  const { documents, filter, handleDownload, handleDelete, setFilter, page, setPage, totalPages, totalDocuments, setToRefresh } = useSearchPage();

  return (
    <>
      <Results totalDocuments={totalDocuments}>
        <TypeDocSelector setFilter={setFilter} filter={filter} />
        <SearchBar redirect />
        <p className="results__searchMessage">
          Foram encontrados <span className="searchMessage__total">{totalDocuments}</span> documento(s) {searchTerm && ' com o termo:'}
          {searchTerm && <span className="searchMessage__term">{searchTerm}</span>}
        </p>
        <Filter setFilter={setFilter} filter={filter} setPage={setPage} />
        {documents?.map((doc) => {
          return (
            <Card
              handleDownload={handleDownload}
              handleDelete={handleDelete}
              key={doc?.ID}
              document={doc}
              setToRefresh={setToRefresh}
              classificacao={doc?.Classificacao}
            />
          );
        })}
        {documents?.length <= 0 && <p className="results__notFound">Não foram encontrados itens com o termo pesquisado</p>}
        <Pagination page={page} setPage={setPage} totalPages={totalPages} />
        <Footer>
          Neste site você poderá efetuar pesquisas na relação de normas técnicas vigentes da Sabesp, para realizar uma busca, basta utilizar a caixa
          de texto acima, que iremos trazer a relação de normas com o conteúdo mais próximo ao texto digitado.
        </Footer>
      </Results>
      {historyModal.isVisible && <HistoryModal />}
      {pdfModal.isVisible && <PdfModal />}
      {validationModal.isVisible && <ValidationModal />}
      {treeModal.isVisible && <TreeModal />}
      {quantidadeModal && <QuantificationModal />}
    </>
  );
};

export default SearchPage;
